/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Vorsorgeaufwendungenid2Inputs */



/**

* @param {_Field_Vorsorgeaufwendungenid2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_vorsorgeaufwendungenid2 = /** @type {((inputs?: _Field_Vorsorgeaufwendungenid2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Vorsorgeaufwendungenid2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Vorsorgeaufwendungen")
});
export { _field_vorsorgeaufwendungenid2 as "_field_vorsorgeaufwendungenID" }